export default {
  afterPrepareShow () {
    this.total = this.statistics.reduce((acc, item) => {
      return acc + item.amount
    }, 0)
  }
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/summary-billing/resources/methods.js